<template>
    <div class="rq-consumer-password-change" >
        <p>Are you sure you would like to change your password?</p>
        <p>You will be redirected...</p>
        <!-- <div class="row" style="align-items: center; margin: 0; padding-top: 10px; padding-bottom: 10px; padding-right: 15px; width: 100%">
            <label
                class="col-sm-12  col-md-6  col-lg-6  col-xl-6"
                for="passwordNew">
                Password:
            </label>
            <b-form-input
                class="col-sm-12  col-md-6  col-lg-6  col-xl-6"
                v-model="passwordNew"
                id="passwordNew"
                type="password"
                :state="this.CheckState(this.passwordNew)"
            />
        </div>
        <div class="row" style="align-items: center; margin: 0; padding-top: 10px; padding-bottom: 10px; padding-right: 15px; width: 100%">
            <label
                class="col-sm-12  col-md-6  col-lg-6  col-xl-6"
                for="passwordConfirm">
                Confirm Password:
            </label>
            <b-form-input
                class="col-sm-12  col-md-6  col-lg-6  col-xl-6"
                v-model="passwordConfirm"
                id="passwordConfirm"
                type="password"
                :state="this.CheckState(this.passwordConfirm)"
            />
        </div> -->


        <!-- WE WILL NEED TO SHOW THE RULES HERE -->
    </div>
</template>

<script>

export default {
    name: 'PasswordChange',
    components: {

    },
    props: {
        userAccountId: Number,
    },
    data() {
        return {
            passwordNew: null,
            passwordConfirm: null,
            isOpen: false,
            documents: [],
        }
    },
    computed: {
        passwordInformation() {
            return {
                passwordNew: this.passwordNew,
                passwordConfirm: this.passwordConfirm,
                validated: this.validated,
            }
        },
        validated () {
            if (this.passwordNew == this.passwordConfirm) {
                return true;
            }
            else {
                return false;
            }
        }
    },
    watch: {
        passwordNew (newValue, oldValue) {
        },
        passwordConfirm (newValue, oldValue) {
        },
        passwordInformation (newValue, oldValue) {
            this.$emit('action', { name: 'PasswordInformationChanged', data: this.passwordInformation });
        }
    },
    created() {
    },
    mounted() {
        const self = this;

        this.$emit('action', { name: 'Open', action: () => { self.Reset() } });
    },
    methods: {
        Reset() {
            const self = this;

            self.passwordNew = null;
            self.passwordConfirm = null;
        },
        CheckState(prop) {
            return prop != null ? (prop ? true : false) : "null";
        },
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>